module.exports = __webpack_public_path__ + "static/media/A1-35-Luzzen-cod143.875fbd7a.png";